import firebase from "firebase";
import { db } from "@/firebase";

export default {
  state: {
    /* User */
    user: null,
    users: [],
    preferences: null,
  },

  mutations: {
    /* User */
    setUser(state, payload) {
      state.user = payload;
    },

    setUsers(state, payload) {
      state.users = payload;
    },

    setPreferences(state, payload) {
      state.preferences = payload;
    },

    removeUser(state) {
      state.user = null;
    },
  },

  actions: {
    /* User */
    signUpAction({ commit, dispatch }, payload) {
      commit("setBtnLoading", true);
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then((response) => {
          const user = response.user;

          // const postData = {
          //   id: user.uid,
          //   firstName: payload.firstName,
          //   lastName: payload.lastName,
          //   email: payload.email
          // }

          // axios
          // .post('users', postData)
          // .then(response => {
          //   const user = response.data.id
          //   dispatch('fetchUser', user)
          // })

          return db
            .ref("users/" + user.uid)
            .set({
              firstName: payload.firstName,
              lastName: payload.lastName,
              email: user.email,
              userId: user.uid,
            })
            .then((response) => {
              dispatch("fetchUser", response);
              commit("setBtnLoading", false);
            });
        })
        .catch((error) => {
          commit("setBtnLoading", false);
          commit("setError", error);
        });
    },

    signInAction({ commit }, payload) {
      commit("setBtnLoading", true);
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(() => {
          commit("setBtnLoading", false);
        })
        .catch((error) => {
          commit("setBtnLoading", false);
          commit("setError", error);
        });
    },

    fetchUser({ commit }, user) {
      db.ref("users/" + user).once("value", (snapshot) => {
        const document = snapshot.val();
        commit("setUser", document);
      });
    },

    fetchPreferences({ commit, state }) {
      const user = state.user.userId;
      db.ref("users/" + user)
        .child("preferences")
        .once("value", (snapshot) => {
          const document = snapshot.val();
          commit("setPreferences", document);
        });
    },

    updatePreferences({ commit, dispatch, state }, payload) {
      commit("setBtnLoading", true);
      const user = state.user.userId;
      db.ref("users/" + user)
        .update({
          preferences: {
            tempInMin: payload.tempInMin,
            tempInMax: payload.tempInMax,
          },
        })
        .then(() => {
          dispatch("fetchPreferences", user);
          commit("setBtnLoading", false);
        });
    },

    // fetchUsers({ commit }) {
    //     axios.get('users')
    //     .then(response => {
    //       const users = response.data
    //       commit('setUsers', users)
    //     })
    //     // db.ref('users/' + user.uid).once('value', snapshot => {
    //     //   const document = snapshot.val()
    //     //   commit('setUser', document)
    //     // })

    // },

    signOutAction({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(() => {
          commit("setUser", null);
        });
    },
  },

  getters: {
    user(state) {
      return state.user;
    },
  },
};
